// Update cart count in nav
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.querySelector('.cart-count');
      if (badge) badge.textContent = cart.item_count;
    });
}

// Size selector
document.querySelectorAll('.size-opt').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.size-grid').querySelectorAll('.size-opt').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});

// VIP form confirmation
function handleVIP(btn) {
  btn.textContent = '✓ You\'re on the list';
  btn.style.background = '#1a1a1a';
  btn.style.color = 'var(--gold)';
  btn.disabled = true;
}

document.addEventListener('DOMContentLoaded', updateCartCount);
